import { useSelector, RootStateOrAny } from 'react-redux';

export default function useContacts() {
  // NWA-2498 Temporary default-value workaround — we still need to investigate why dataAll is being set to undefined
  const {
    dataAll: allContacts = [],
    dataPersonal: personalContacts = [],
  } = useSelector((state: RootStateOrAny) => state.contact ?? {});

  const allContactsContactsFlatMap = allContacts.flatMap(
    (group: { data: any }) => group.data
  );

  const personalContactsFlatMap = personalContacts.flatMap(
    (group: { data: any }) => group.data
  );

  const allowedContacts = [
    ...allContactsContactsFlatMap,
    ...personalContactsFlatMap,
  ];

  const contacts = allowedContacts.map((contact: any) => ({
    ...contact,
  }));

  return { contacts };
}
